import { createFileRoute, Link } from "@tanstack/react-router";
import { ProsePage } from "../components/prose-page.tsx";

export const Route = createFileRoute("/terms")({ component: TermsPage });

/**
 * Plain-language terms.
 *
 * Deliberately short and readable rather than exhaustive. This is a placeholder
 * for the JDA's counsel to replace before launch — it states what the platform
 * actually does, which is the part engineering can be accurate about.
 */
function TermsPage() {
	return (
		<ProsePage
			title="Terms of use"
			intro="The short version: post real jobs, be accurate, and treat people decently."
			updated="13 August 2026"
		>
			<h2>Who runs this</h2>
			<p>
				NWGA Connect is operated by the Northwest Georgia Joint Development
				Authority as a free service for the region.
			</p>

			<h2>Using the board</h2>
			<p>
				Browsing and applying need no account and cost nothing. Applications go
				directly to the employer; we are not party to them and do not receive
				them.
			</p>

			<h2>If you post listings</h2>
			<ul>
				<li>
					You must be authorised to hire on behalf of the business you register.
				</li>
				<li>
					Listings must describe genuine, currently open roles, with accurate
					pay, location and employment terms.
				</li>
				<li>
					No fees may be charged to applicants, and no listing may require
					payment, a purchase, or a financial commitment to apply.
				</li>
				<li>
					No unlawful discrimination in a listing, and nothing that would breach
					federal or Georgia employment law.
				</li>
				<li>
					You are responsible for what you publish; it is your content, not
					ours.
				</li>
			</ul>

			<h2>Review, suspension and removal</h2>
			<p>
				Every business is reviewed before its listings appear publicly. We may
				decline a registration, suspend a business, or remove a listing that
				breaches these terms. When we do, we tell you why in writing, and you
				may reply and ask us to look again.
			</p>

			<h2>What we do not promise</h2>
			<p>
				We do not verify the accuracy of any listing beyond reviewing the
				business behind it, and we do not guarantee that any role exists,
				remains open, or leads anywhere. The service is provided as-is, and may
				be unavailable from time to time.
			</p>

			<h2>Your account</h2>
			<p>
				Keep your password to yourself and tell us if you think somebody else
				has it. You can close your account at any time from your settings,
				unless you are the last owner of a business — transfer ownership first.
			</p>

			<h2>Changes</h2>
			<p>
				We will post any change here and update the date above. Continuing to
				use the service after a change means you accept it.
			</p>

			<p>
				See also the <Link to="/privacy">privacy policy</Link>.
			</p>
		</ProsePage>
	);
}
